import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:5000/api";

// Create axios instance with credentials for cookie-based auth
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Enable cookies
});

/**
 * Start a match for live scoring
 */
export const startMatchScoring = async (matchId) => {
  try {
    const response = await apiClient.post(
      `/matches/${matchId}/scoring/start`,
      {}
    );
    return response.data;
  } catch (error) {
    console.error("Start match scoring error:", error);
    throw error.response?.data || error;
  }
};

/**
 * Score a point in current game
 */
export const scorePoint = async (matchId, gameNumber, scoringPlayer) => {
  try {
    const response = await apiClient.post(
      `/matches/${matchId}/scoring/point`,
      {
        gameNumber,
        scoringPlayer,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Score point error:", error);
    throw error.response?.data || error;
  }
};

/**
 * Get current match score and state
 */
export const getMatchScore = async (matchId) => {
  try {
    const response = await apiClient.get(`/matches/${matchId}/scoring`);
    return response.data;
  } catch (error) {
    console.error("Get match score error:", error);
    throw error.response?.data || error;
  }
};
